const getWorkflow = (config, zone) => {
  let zoneUnique;
  if (zone && zone === 'SB_ZONE_UNAVAILABLE' && config.upcId) {
    zoneUnique = `${zone}-${config.upcId}`;
  } else {
    const productId = config.memberProductId ? config.memberProductId : config.productId;
    zoneUnique = productId ? `${zone}-${productId}` : zone;
  }

  const { requester, selectedColorFamily } = config;

  if (selectedColorFamily) {
    return `${requester}-${zoneUnique}-${selectedColorFamily}`;
  }

  return `${requester}-${zoneUnique}`;
};

export default getWorkflow;
